import { Button } from "@cometchat-ai/ui-dashboard";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

/**
 * 404 page. Does NOT distinguish "unknown URL" from "you're not in that
 * workspace" — per FD R2 the dashboard never leaks the existence of
 * resources the user isn't a member of.
 */
export function NotFoundRoute() {
  const { t } = useTranslation("common");
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-4xl font-semibold">404</h1>
      <p className="text-sm text-muted-foreground">{t("errors.genericDescription")}</p>
      <Button asChild variant="outline">
        <Link to="/">{t("buttons.back")}</Link>
      </Button>
    </main>
  );
}
